export const tabIndexSelector = (state) => state.uiState.app.tabIndex
